import { trackAction } from "@/integrations/datadog/track";

export type LoginMethod = "password" | "password_reset" | "sms_otp";

/**
 * Methods that can complete a signed-in session. `password_reset` only sets a
 * new credential — it does not sign the user in.
 */
export type CompletedLoginMethod = Exclude<LoginMethod, "password_reset">;

function getAuthErrorCode(error: unknown) {
  if (error instanceof Error && error.name !== "Error") {
    return error.name;
  }

  return "unknown";
}

/** Records a successful login action by authentication method. */
export function trackLoginCompleted(method: CompletedLoginMethod) {
  trackAction("auth.login.completed", { method });
}

/** Records a login failure with a normalized, non-PII error code. */
export function trackLoginFailed(method: LoginMethod, errorCode: string) {
  trackAction("auth.login.failed", {
    method,
    error_code: errorCode,
  });
}

/** Extracts a safe failure code from an error and records the login failure. */
export function trackLoginError(method: LoginMethod, error: unknown) {
  trackLoginFailed(method, getAuthErrorCode(error));
}
